import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  Home, 
  Shield, 
  Globe,
  Package,
  Truck
} from 'lucide-react';

const Sitemap: React.FC = () => {
  const siteStructure = [
    {
      title: 'Main Pages',
      icon: <Home size={20} />,
      links: [
        { label: 'Home', path: '/', description: 'Landing page with enquiry form, services, and company overview' },
        { label: 'Services', path: '/services', description: 'Detailed list of all courier and logistics services' },
        { label: 'About Us', path: '/about', description: 'Company information, team, mission and vision' },
        { label: 'Contact', path: '/contact', description: 'Contact form, phone numbers, email, and office address' }
      ]
    },
    {
      title: 'Our Services',
      icon: <Package size={20} />,
      links: [
        { label: 'Document Courier', path: '/services', description: 'International document shipping — certificates, passports, legal papers' },
        { label: 'Parcel Courier', path: '/services', description: 'Personal parcels, gifts, and household items worldwide' },
        { label: 'Medicine Courier', path: '/services', description: 'Safe international medicine delivery with proper handling' },
        { label: 'Food Items Courier', path: '/services', description: 'Homemade food, spices, sweets, and dry items abroad' },
        { label: 'Commercial Shipment', path: '/services', description: 'Bulk and business shipments with customs support' },
        { label: 'Excess Baggage', path: '/services', description: 'Ship extra luggage at lower rates than airlines' }
      ]
    },
    {
      title: 'Countries We Serve',
      icon: <Globe size={20} />,
      links: [
        { label: 'Courier to USA', path: '/#countries', description: 'International courier from Chandigarh to United States — 5–7 days' },
        { label: 'Courier to Canada', path: '/#countries', description: 'International courier from Chandigarh to Canada — 5–7 days' },
        { label: 'Courier to United Kingdom', path: '/#countries', description: 'International courier from Chandigarh to UK — 4–6 days' },
        { label: 'Courier to Australia', path: '/#countries', description: 'International courier from Chandigarh to Australia — 5–8 days' },
        { label: 'Courier to Dubai / UAE', path: '/#countries', description: 'International courier from Chandigarh to Dubai — 3–5 days' },
        { label: 'Courier to Europe', path: '/#countries', description: 'International courier from Chandigarh to European countries — 5–7 days' }
      ]
    },
    {
      title: 'Service Areas',
      icon: <Truck size={20} />,
      links: [
        { label: 'Chandigarh', path: '/', description: 'International courier service in Chandigarh with free doorstep pickup' },
        { label: 'Mohali', path: '/', description: 'International courier service in Mohali — IT Park, Phase areas' },
        { label: 'Panchkula', path: '/', description: 'International courier service in Panchkula — all sectors' },
        { label: 'Zirakpur', path: '/', description: 'International courier service in Zirakpur and surrounding areas' }
      ]
    },
    {
      title: 'Legal',
      icon: <Shield size={20} />,
      links: [
        { label: 'Privacy Policy', path: '/privacy', description: 'How we collect, use, and protect your personal information' },
        { label: 'Terms of Service', path: '/terms', description: 'Terms and conditions for using our services' },
        { label: 'Sitemap', path: '/sitemap', description: 'Complete site navigation map (this page)' }
      ]
    }
  ];

  return (
    <div className="legal-page">
      <section className="page-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>Sitemap</h1>
            <p>Complete navigation guide for Pack N Fly website</p>
          </motion.div>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="sitemap-wrapper">
            {siteStructure.map((section, sectionIndex) => (
              <motion.div
                key={section.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: sectionIndex * 0.1 }}
                className="sitemap-section"
              >
                <div className="sitemap-section-header">
                  {section.icon}
                  <h2>{section.title}</h2>
                </div>
                <div className="sitemap-links">
                  {section.links.map((link, linkIndex) => (
                    <Link
                      key={linkIndex}
                      to={link.path}
                      className="sitemap-link-item"
                    >
                      <h3>{link.label}</h3>
                      <p>{link.description}</p>
                    </Link>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sitemap;
